/**
 * Created by Jie Gao on 3/20/2019.
 */

import {AvalancheParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheParsedServerData";
import {GGServerDataParser} from "../GGServerDataParser";
import {IGGGameData, IGGServerData, ITopTrain, IXBomb} from "./IGGServerData";
import {GGGameConfig} from "../../GGGameConfig";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GGGameMode} from "../../gamemode/GGGameMode";

export class GGParsedGameData extends AvalancheParsedGameData {
    private readonly _evaluatedArea:string[][];
    private readonly _numberOfWaysWon:number;
    private readonly _gameAreaSize:number;
    //private readonly _gameSizeEnteringFreespin: number;
    private readonly _avalancheTotalWin:number;
    private readonly _currentAvalancheWinRatio:number;
    private readonly _currentAvalancheWinRatioConfig:IWinRatioConfig | null;
    //bigwin
    private readonly _currentBigWinWinRatio:number;
    private readonly _isEndBigWin:boolean;

    private readonly _wasRandomBuy:boolean;
    public get wasRandomBuy():boolean {
        return this._wasRandomBuy;
    }

    private readonly _numScattersEnterFS:number;
    public get numScattersEnterFS():number {
        return this._numScattersEnterFS;
    }

    private readonly _gameAreaSizeNextSpin:number;
    public get gameAreaSizeNextSpin():number {
        return this._gameAreaSizeNextSpin;
    }

    private _doubleBombSpins:number;
    public get doubleBombSpins():number {
        return this._doubleBombSpins;
    }

    private readonly _topTrain:ITopTrain;
    public get topTrain():ITopTrain {
        return this._topTrain;
    }

    private readonly _xBombs:IXBomb;
    public get xBombs():IXBomb {
        return this._xBombs;
    }

    private readonly _dwTransform:boolean[];
    public get dwTransform():boolean[] {
        return this._dwTransform;
    }

    private readonly _scattersOnReel:number[];
    public get scattersOnReel():number[] {
        return this._scattersOnReel;
    }

    private readonly _scattersOnReelAfterCollapse:number;
    public get scattersOnReelAfterCollapse():number {
        return this._scattersOnReelAfterCollapse;
    }

    private readonly _deadWildsOnReel:number[];
    public get deadWildsOnReel():number[] {
        return this._deadWildsOnReel;
    }

    private readonly _deadWildsOnReelAfterCollapse:number;
    public get deadWildsOnReelAfterCollapse():number {
        return this._deadWildsOnReelAfterCollapse;
    }

    private readonly _numberOfScattersBefore:number;
    public get numberOfScattersBefore():number {
        return this._numberOfScattersBefore;
    }

    private readonly _numberOfScatters:number;
    public get numberOfScatters():number {
        return this._numberOfScatters;
    }

    private readonly _isFreespin:boolean;

    public get isFreespinMode():boolean {
        return this._isFreespin;
    }

    private readonly _isAvalanche:boolean;

    public get isAvalancheMode():boolean {
        return this._isAvalanche;
    }

    private readonly _isNextAvalanche:boolean;

    public get isNextAvalancheMode():boolean {
        return this._isNextAvalanche;
    }

    private readonly _isNextNormal:boolean;

    public get isNextNormalMode():boolean {
        return this._isNextNormal;
    }

    private readonly _brokeBank:boolean;
    public get brokeBank():boolean {
        return this._brokeBank;
    }

    private readonly _topTrainAnticipation:boolean[];
    public get topTrainAnticipation():boolean[] {
        //return [false, false, true, true];
        return this._topTrainAnticipation;
    }

    private readonly _roundType:number;
    public get roundType():number {
        return this._roundType;
    }

    private readonly _bombGuarantee:boolean;
    public get bombGuarantee():boolean {
        return this._bombGuarantee;
    }

    private readonly _totalNumberOfWays:number[];
    public get totalNumberOfWays():number[] {
        return this._totalNumberOfWays;
    }

    private readonly _multiplierBeforeFeast:number;
    public get multiplierBeforeFeast():number {
        return this._multiplierBeforeFeast;
    }

    constructor(rawData:IGGGameData, dataParser:GGServerDataParser) {
        super(rawData, dataParser);
        this._xBombs = rawData.xBombs;
        this._gameAreaSize = rawData.gameAreaSize;
        //this._gameSizeEnteringFreespin = rawData.gameSizeEnteringFreespin[0];
        this._evaluatedArea = rawData.evaluatedArea;
        this._totalNumberOfWays = rawData.totalNumberOfWays;
        this._numberOfWaysWon = rawData.numberOfWaysWon;
        this._gameAreaSizeNextSpin = rawData.gameAreaSizeNextSpin;

        this._dwTransform = rawData.z2Wild;
        this._numberOfScatters = rawData.numberOfScatters;
        this._numberOfScattersBefore = rawData.numberOfScattersBefore;
        this._isFreespin = this.isFreespin(rawData);
        this._isAvalanche = this.isAvalanche(rawData);
        this._isNextAvalanche = this.isNextAvalanche(rawData);
        this._isNextNormal = this.isNextNormal(rawData);
        this._brokeBank = rawData.brokeBank;
        this._xBombs = rawData.xBombs;
        this._bombGuarantee = rawData.bombGuarantee;
        this._topTrain = rawData.topTrain;
        this._topTrainAnticipation = GGParsedGameData.parseTopTrainAnticipation(rawData);
        this._scattersOnReel = GGParsedGameData.getSpecialOnReel(rawData.reels, "S");
        this._scattersOnReelAfterCollapse = GGParsedGameData.getSpecialOnReelAfterCollapse(this._isNextAvalanche,rawData.reelsAfterCollapse, "S");
        this._deadWildsOnReel = GGParsedGameData.getSpecialOnReel(rawData.reels, "Z");
        this._deadWildsOnReelAfterCollapse = GGParsedGameData.getSpecialOnReelAfterCollapse(this._isNextAvalanche,rawData.reelsAfterCollapse, "Z");
        this._roundType = rawData.roundType;
        this._doubleBombSpins = rawData.doubleBombSpins;
        this._wasRandomBuy = rawData.wasRandomBuy;
        this._multiplierBeforeFeast = rawData.multiplierBeforeFeast;
        this._numScattersEnterFS = rawData.freespinsLeft! + rawData.numberOfFreespinsPlayed!;

        this._avalancheTotalWin = dataParser.parseAvalancheTotalWin(rawData);
        //bigwin
        this._currentBigWinWinRatio = this._avalancheTotalWin / Number(rawData.playedBetValue);
        this._isEndBigWin = this._currentBigWinWinRatio >= GGGameConfig.instance.WIN_RATIOS.bigWin[0].ratio && !rawData.brokeBank;
        this._currentAvalancheWinRatio = this._avalancheTotalWin / Number(rawData.playedBetValue);
        this._currentAvalancheWinRatioConfig = GGParsedGameData.getAvalancheWinRatioConfig(this._currentAvalancheWinRatio);
    }

    protected isFreespin(rawData:IServerData):boolean {
        return (rawData.mode.indexOf("FREESPIN") > -1);
    }

    protected isAvalanche(rawData:IServerData):boolean {
        return (rawData.mode === GameMode.NORMAL_AVALANCHE || rawData.mode === GameMode.FREESPIN_AVALANCHE);
    }

    private isNextAvalanche(rawData:IServerData):boolean {
        return (rawData.nextMode === GameMode.NORMAL_AVALANCHE || rawData.nextMode === GameMode.FREESPIN_AVALANCHE);
    }

    private isNextNormal(rawData:IServerData):boolean {
        return (rawData.nextMode === GameMode.NORMAL_AVALANCHE || rawData.nextMode === GameMode.NORMAL || rawData.nextMode === GGGameMode.DOUBLE_BOMB);
    }

    private static parseTopTrainAnticipation(rawData:IGGGameData):boolean[] {
        const isNormalMode:boolean = (rawData.mode === GameMode.NORMAL_AVALANCHE || rawData.mode === GameMode.NORMAL);

        if(rawData.wasRandomBuy && isNormalMode){
            const topTrainAnticipation:boolean[] = [];
            rawData.topTrainAnticipation.forEach((hasAnticipation:boolean, i:number)=>{
                let temp:boolean = hasAnticipation;
                if(i===2){
                    temp = false;
                }else if(i===3){
                    const  isAvalanche:boolean = rawData.mode === GameMode.NORMAL_AVALANCHE;
                    temp = !isAvalanche && (rawData.topTrain.beforeSpellSymbols[2] === rawData.topTrain.beforeSpellSymbols[1]);
                }
                topTrainAnticipation.push(temp);
            });
            return topTrainAnticipation;
        }
        return  rawData.topTrainAnticipation;
    }
    private static getSpecialOnReel(reels:string[][], symbolName:string):number[] {
        let scatterNr = 0;
        const scatterNrOnReel:number[] = [];
        reels.forEach((symbols:string[]) => {
            scatterNrOnReel.push(scatterNr);
            symbols.forEach((symbol:string) => {
                if(symbol === symbolName) {
                    scatterNr++;
                }
            });
        });
        return scatterNrOnReel
    }

    private static getSpecialOnReelAfterCollapse(isNextAvalanche:boolean, reelsAfterCollapse:string[][], symbolName:string):number {
        if(!isNextAvalanche) {
            return 0;
        }
        let scatterNr = 0;
        reelsAfterCollapse.forEach((symbols:string[]) => {
            symbols.forEach((symbol:string) => {
                if(symbol === symbolName) {
                    scatterNr++;
                }
            });
        });
        return scatterNr
    }

    private static getAvalancheWinRatioConfig(winRatio:number):IWinRatioConfig | null {
        let winLevels:IWinRatioConfig[] = GameConfig.instance.WIN_RATIOS.normalWin.concat();
        winLevels = winLevels.concat(GameConfig.instance.WIN_RATIOS.bigWin);

        for(let i:number = winLevels.length - 1; i >= 0; i--) {
            const winLevel = winLevels[i];
            if(winRatio >= winLevel.ratio) {
                return winLevel;
            }
        }
        return null;
    }

    public get currentAvalancheWinRatioConfig():IWinRatioConfig | null {
        return this._currentAvalancheWinRatioConfig;
    }

    public get avalancheTotalWin():number {
        return this._avalancheTotalWin;
    }

    public get currentBigWinWinRatio():number {
        return this._currentBigWinWinRatio;
    }

    public get isEndBigWin():boolean {
        return this._isEndBigWin;
    }

    public get evaluatedArea():string[][] {
        return this._evaluatedArea;
    }

    public get gameAreaSize():number {
        return this._gameAreaSize;
    }

    //public get gameSizeEnteringFreespin(): number {
    //    return this._gameSizeEnteringFreespin;
    //}
}